import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie';

Vue.use(Vuex);

const AUTH_KEY = 'AUTH'
const SETTINGS_KEY = 'SETTINGS';
const EXPIRATION_GENERAL = 30; // days


function initialAuth() {
  try {
    return JSON.parse(Cookies.get(AUTH_KEY));
  } catch (err) {
    return null;
  }
}

function initialSettings() {

  //DEFAULT SETTINGS
  const defaultSettings = {
    localization: "en"
  }

  try {
    const cookiesLoaded = JSON.parse(Cookies.get(SETTINGS_KEY));
    if (!cookiesLoaded.hasOwnProperty("localization")) {
      return defaultSettings;
    }

    return cookiesLoaded;
  } catch (err) {
    return defaultSettings;
  }
}




const cookiesStore = {
  namespaced: false,
  state: {
    auth: initialAuth(),
    settings: initialSettings(),
  },
  mutations: {
    setAuth(state, value) {
      //expires null mean end of relation
      Cookies.set(AUTH_KEY, JSON.stringify(value), { expires: null, secure: false, sameSite: 'strict' });
      state.auth = value;
    },
    setLocation(state, payload) {
      state.settings.localization = payload;
      Cookies.set(SETTINGS_KEY, JSON.stringify(state.settings), { expires: EXPIRATION_GENERAL, secure: false, sameSite: 'strict' });
    },

    Logout(state) {
      Cookies.remove(AUTH_KEY);
      state.auth = null;
    }
  },
  getters: {
    getAuth(state) {
      return state.auth;
    },
    getSettings(state) {
      return state.settings;
    },
  },
}

const wsStore = {
  namespaced: false,
  state: {
    connected: false,
    message: "",
    notifications: []
  },
  mutations: {
    setConnected(state, value) {
      state.connected = value;
    },
    setDataMessage(state, msg) {
      state.message = msg
    }
  },
  getters: {
    isConnected(state) {
      return state.connected;
    },
    getDataMessage(state) {
      if (state.message) {
        try {
          return state.message.data;
        } catch (err) {
          console.log("Unable parse");
          return "";
        }
      }
    },
    getPayload(state) {
      if (state.message) {
        try {
          return state.message;
        } catch (err) {
          console.log("Unable parse");
          return "";
        }
      }
    }
  },
  actions: {
    sendMessage: function (context, message) {
      Vue.prototype.$socket.send(message)
    }
  }
}



const store = new Vuex.Store({
  modules: {
    cookies: cookiesStore,
    ws: wsStore,
  }
});


export default store